import React from 'react';
import PropTypes from 'prop-types';
import { values } from 'lodash/fp';

import CloseIcon from '../../themes/svg/closeIcon';
import { ResponsiveModal as StyledModal, Title, CloseButton } from './styles';
import { useModalProviderContext } from '../ModalProvider';
import * as modalNames from '../ModalProvider/modalNames';

const ResponsiveModal = ({
  modalName,
  title,
  children,
  size,
  ...props
}) => {
  const { isOpen, setIsOpen } = useModalProviderContext(modalName);

  return (
    <StyledModal
      {...props}
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      size={size}
      style={{
          overlay: {
            zIndex: 100,
            backgroundColor: 'rgba(0, 0, 0, .8)',
          },
        }}
    >
      <Title>
        {title}
        <CloseButton id="closeModalButton" title="close" onClick={() => setIsOpen(false)} tabIndex="-1" role="button">
          <CloseIcon />
        </CloseButton>
      </Title>
      {children}
    </StyledModal>
  );
};
ResponsiveModal.propTypes = {
  modalName: PropTypes.oneOf(values(modalNames)).isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['large', 'small']),
};
ResponsiveModal.defaultProps = {
  size: 'large',
};
export default ResponsiveModal;
